import React from 'react';
import MobileLayout from './MobileLayout';
import CreateSubmissionOnBehalf from '../tradeups/CreateSubmissionOnBehalf';

/** The create-submission form inside the mobile shell, for staff working from a phone or tablet. */
const CreateSubmissionMobile: React.FC = () => (
  <MobileLayout>
    <CreateSubmissionOnBehalf />
  </MobileLayout>
);

export default CreateSubmissionMobile;
